import scrollTo from 'scroll-to-element';

export default {
  scrollToFunc: (hash) => {
    const scrollToAnchor = () => {
      const element = document.querySelector(hash);
      if (element) scrollTo(hash, { offset: -70 });
    };
    scrollToAnchor();
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/scrollTo.js